import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.doesAtLeastOneFilterHaveSelectedOption)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "OptionalFilterBlock ClearOptionalFiltersButton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "OptionalFilterBlockTextWrapper" }, [
          _createElementVNode("span", { class: "OptionalFilterBlockText" }, " Clear filters ")
        ], -1 /* CACHED */)
      ])))
    : _createCommentVNode("v-if", true)
}